export const GBP = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" });

export function formatGBP(v) {
  const n = Number(v || 0);
  return GBP.format(n);
}

export function formatUKDate(isoDate) {
  if (!isoDate) return "";
  // accepts YYYY-MM-DD or full ISO string
  const d = typeof isoDate === "string" && isoDate.length === 10 ? new Date(isoDate + "T00:00:00") : new Date(isoDate);
  if (isNaN(d.getTime())) return isoDate;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatUKDateShort(isoDate) {
  if (!isoDate) return "";
  const d = typeof isoDate === "string" && isoDate.length === 10 ? new Date(isoDate + "T00:00:00") : new Date(isoDate);
  if (isNaN(d.getTime())) return isoDate;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit" });
}

export function formatUKDay(isoDate) {
  if (!isoDate) return "";
  const d = typeof isoDate === "string" && isoDate.length === 10 ? new Date(isoDate + "T00:00:00") : new Date(isoDate);
  return d.toLocaleDateString("en-GB", { weekday: "short" });
}

export function todayISO() {
  const now = new Date();
  const tz = now.getTimezoneOffset();
  const local = new Date(now.getTime() - tz * 60000);
  return local.toISOString().slice(0, 10);
}

export function addDaysISO(isoDate, days) {
  const d = new Date(isoDate + "T00:00:00");
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export function startOfWeekISO(iso) {
  const d = new Date(iso + "T00:00:00");
  const day = (d.getDay() + 6) % 7; // Monday start
  d.setDate(d.getDate() - day);
  return d.toISOString().slice(0, 10);
}
